import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { 
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,
 } from "reactstrap"
import { connect, useDispatch } from "react-redux";
import { withRouter, Link} from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Loader from "../../components/Common/Loader"
import Pagination from "../../components/Common/Pagination"

import { campaignList, campaignFilter } from "../../store/campaign/actions"

const Campaign = (props) => {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");

  const onChange = (e) => {
    setSearch(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(campaignFilter(`?search=${search}`));
  };

  const resetSearch = () => {
    dispatch(campaignFilter(`?search=`));
    setSearch("");
  };


  useEffect(() => {

    dispatch(campaignList())

  }, [dispatch])

  const params = {
    count: props.campaign.count,
    next: props.campaign.next,
    previous: props.campaign.previous,
    results: props.campaign.results,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>  | Campañas </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="" breadcrumbItem=" Campañas" />

          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={7}>
                      <Link
                        className="btn btn-primary waves-effect waves-light mb-1"
                        to="/campaign/create"
                      >
                        Agregar
                      </Link>
                    </Col>
                    <Col md={5}>
                      <Form className="search-box" onSubmit={onSubmit}>
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            placeholder="Código, nombre, descripción..."
                            value={search}
                            onChange={onChange}
                          />
                          <i className="bx bx-search-alt search-icon" />
                          <Button color="primary" onClick={resetSearch}>
                            <span className=" bx bx-x fa-lg align-middle"></span>
                          </Button>
                        </InputGroup>
                      </Form>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                {params.results ? (
                  <CardBody className="ps-5 pe-5">
                    <h2 className="mb-3 font-size-20">Lista de Cuentas</h2>
                    <div className="table-responsive">
                      <Table
                        className="table table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Descripción</th>
                            <th>Cuenta</th>
                            <th>Encargado</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {params.results.map((campaign, idx) => (
                            <tr key={idx}>
                              <th >{idx +1}</th>
                              <td >{campaign.name}</td>
                              <td>{campaign.description}</td>
                              <td>{campaign.account}</td>
                              <td>{campaign.encargado}</td>
                              <td>
                                <Link to={`/campaign/update/${campaign.id}`}>
                                  <span className="bx bx-edit fa-lg align-middle"></span>
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={10}
                      baseUrl="produccion/campaign/"
                      filterFunction={campaignFilter}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}


const mapStateToProps = (state) => {
  const { error, loading, campaign } = state.Campaign;
  return { error, loading, campaign };
};

export default withRouter(connect(mapStateToProps)(Campaign));
